import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "downloadCancel",
  "use": "downloadCancel-usage",
  "viewBox": "0 0 244.7 244.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 244.7 244.7\" id=\"downloadCancel\"><style></style><circle cx=\"121.9\" cy=\"122.2\" r=\"121.7\" fill=\"none\" /><path class=\"st2\" d=\"M153 153.3c-2.5 2.5-6.7 2.5-9.2 0L122 131.5l-21.8 21.8c-2.5 2.5-6.7 2.5-9.2 0s-2.5-6.7 0-9.2l21.8-21.8-21.9-21.9c-2.5-2.5-2.5-6.7 0-9.2s6.7-2.5 9.2 0l21.8 21.8 21.8-21.8c2.5-2.5 6.7-2.5 9.2 0s2.5 6.7 0 9.2l-21.8 21.8 21.8 21.8c2.6 2.7 2.6 6.8.1 9.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol